<template>
  <q-page padding>
    <PageHeader :backRoute="{ name: 'home' }" backBehavior="route">
      <template #title>Bem Vindo</template>
      <template #actions>
        <span class="text-h6 q-ml-sm text-weight-bolder text-brand-1">
          - {{ usuarioLogado?.nome }}
        </span>
      </template>
    </PageHeader>

    <section class="row">
      <div
        @click="goPage(menus.name)"
        :class="[index % 2 == 0 ? 'background-type-1' : 'background-type-2']"
        class="card-style"
        v-for="(menus, index) in routesSimplificado"
        :key="index"
      >
        <q-icon size="40px" :name="menus?.meta?.icon" />
        <span style="text-align: center">{{ menus?.meta?.label }}</span>
      </div>
    </section>
  </q-page>
</template>

<script>
import { ref, onMounted, computed } from "vue";

import { useRouter } from "vue-router";

import { useQuasar } from "quasar";
import { useStore } from "vuex";
import PageHeader from "../../../components/PageHeader.vue";

export default {
  components: {
    PageHeader,
  },
  setup() {
    const quasar = useQuasar();
    const routesSimplificado = ref([
      { name: "spf-user", meta: { label: "Usuários", icon: "person" } },
      {
        name: "spf-retirada",
        meta: { label: "Retirada de Materiais", icon: "shopping_cart" },
      },
      {
        name: "spf-retirada-exporadica",
        meta: { label: "Retirada Esporádica", icon: "shopping_cart_checkout" },
      },
      {
        name: "spf-materiais",
        meta: { label: "Listagem de Requisições", icon: "receipt_long" },
      },
      {
        name: "spf-status",
        meta: { label: "Consultar Status", icon: "add_task" },
      },
    ]);
    const router = useRouter();
    const store = useStore();
    const filtros = ref({
      unidadeDestino: null,
      unidadeOrigem: null,
      dataInicial: null,
      dataFinal: null,
      status: null,
      numeroPicking: null,
    });
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const disable = ref(false);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 50,
      rowsNumber: 50,
    });

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        filtros.value.unidade = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    const goPage = async (name) => {
      router.push({ name: name });
    };

    let usuarioLogado = computed(
      () => store.getters["autenticacao/usuarioLogado"]
    );

    return {
      getUnidade,
      filtros,
      pagination,
      disable,
      mobile,

      goPage,
      usuarioLogado,
      routesSimplificado,
    };
  },
};
</script>

<style scoped>
.card-style {
  max-width: 161px;
  max-height: 156px;
  width: 100%;
  height: 156px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-left: 20px;
  margin-top: 25px;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

.background-type-1:hover {
  background-color: #304f78dc !important;
}

.background-type-2:hover {
  background-color: #21324adc !important;
}

.background-type-1 {
  background-color: #304f78;
  color: white;
}
.background-type-2 {
  background-color: #21324a;
  color: white;
}
</style>
